module.exports = __webpack_public_path__ + "img/meter-title.b4b75da0.png";